// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__1YB3J","active":"Uploader_active__3NUlj"};